module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/admin/admin-customers/user-list/user-list.component.scss
// module id = ./src/app/components/admin/admin-customers/user-list/user-list.component.scss
// module chunks = main